import wretch from 'wretch';
import formData from 'wretch/addons/formData';
import queryString from 'wretch/addons/queryString';

// API URL constants
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUTH_API_URL = '/authorization';
export const CLIENT_API_URL = '/clients';
export const NOTIFICATION_API_URL = '/notifications';
export const POLICY_API_URL = '/clinicalpolicy';
export const PRESCRIBERS_API_URL = '/prescribers';
export const REFERENCE_API_URL = '/reference';
export const SCOPE_ASSESSOR_API_URL = '/scope-assessor';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = {
    base: wretch(process.env.REACT_APP_BASE_URL).addon([formData, queryString]),
};

/**
 * Returns wretcher w/ Bearer token and optional x-npi header
 * @param {string} url url to append to the BASE_URL
 * @param {string} npi optional npi to be sent as x-npi header
 */
export const fmhNpiAPI = ({ url, npi }) =>
    fmhAPI.base.headers(npi ? { 'x-npi': npi } : undefined).url(url);
